// ** Logo
import whitelogo from "@src/assets/images/logo/logo.png";
import logo from "@src/assets/images/logo/logo.png";
import './smstyle.scss'

const SmSpinn = () => {
	return (
			<div className="d-flex justify-content-center align-items-center background-glasssm">
				<div className="fallback-spinnersm app-loadersm background-lightsm" >
					<div className="loadingsm">
						<div className="effect-1sm effectssm"></div>
						<div className="effect-2sm effectssm"></div>
						<div className="effect-3sm effectssm"></div>
					</div>
				</div>
			</div>
			)
};

export default SmSpinn;
